import { Component, OnInit, Input } from '@angular/core';
import {Country, TreatyNewsCount} from '../../models/treaty.models';
import {TreatyApiService} from '../../services/treaty.service';
import { FuseSplashScreenService } from '@barebone-fuse-services/splash-screen.service';

@Component({
    standalone: false,
    selector: 'particle-treaty-news',
  templateUrl: './treaty-news.component.html',
  styleUrls: ['./treaty-news.component.scss']
})
export class TreatyNewsComponent implements OnInit {
  country1: Country;
  country2: Country;
  id: string;
  id1: string;
  id2: string;
  newsCount: TreatyNewsCount;
  @Input() info: {country1: Country , country2: Country};
  constructor(private treatyService: TreatyApiService, private fuseSplashService: FuseSplashScreenService) { }

  ngOnInit() {
    console.log(this.info);
    this.country1 = this.info.country1;
    this.country2 = this.info.country2;
    this.id = `${this.info.country1.id}-${this.info.country2.id}`;
    this.id1 = `${this.info.country1.id}`;
    this.id2 = `${this.info.country2.id}`;
    this.fuseSplashService.show();
    this.treatyService.getTreatyNewsCountById(this.id).subscribe( data => {
      this.fuseSplashService.hide();
      this.newsCount = data;
    })
  }

}
